var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1634_10532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3859 6.04707L13.3114 1.97249C12.9752 1.63629 12.6341 1.46582 12.2978 1.46582C11.8361 1.46582 11.2969 1.81703 11.2969 2.80686V4.19405C8.33657 4.32307 5.57205 5.53712 3.46352 7.64555C1.23026 9.87864 0.0002461 12.8478 6.38444e-09 16.006C-3.51499e-05 16.2329 0.145125 16.4344 0.360352 16.5062C0.415266 16.5245 0.471551 16.5334 0.527273 16.5334C0.689941 16.5334 0.847406 16.4579 0.948973 16.3228C3.43863 13.0088 7.18703 11.0503 11.2969 10.8956V12.2614C11.2969 13.2512 11.8361 13.6025 12.2978 13.6025H12.2978C12.6341 13.6025 12.9752 13.432 13.3114 13.0958L17.3859 9.02122C17.7819 8.62529 18 8.09717 18 7.53418C18 6.97115 17.7819 6.44303 17.3859 6.04707ZM16.6402 8.27545L12.5656 12.3501C12.4874 12.4282 12.4227 12.4776 12.375 12.5076C12.3624 12.4526 12.3516 12.372 12.3516 12.2615V10.3584C12.3516 10.0672 12.1154 9.83107 11.8242 9.83107C9.48115 9.83107 7.24222 10.3679 5.16973 11.4266C3.68191 12.1866 2.32186 13.2098 1.17011 14.4282C1.9363 9.23574 6.42231 5.23728 11.8242 5.23728C12.1154 5.23728 12.3516 5.00117 12.3516 4.70993V2.80686C12.3516 2.69636 12.3624 2.61568 12.3749 2.56076C12.4227 2.59075 12.4874 2.64011 12.5656 2.71826L16.6402 6.79287C16.837 6.98964 16.9453 7.25289 16.9453 7.53418C16.9453 7.81543 16.837 8.07868 16.6402 8.27545Z",
    fill: "#768D89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_10532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvite);
export default __webpack_public_path__ + "static/media/resend_invite.6acd088688800ddaf0027eca9f1f4c9a.svg";
export { ForwardRef as ReactComponent };